/**
 * @file paddle hack banner
 * @author wanzhongyun
 */

import React from 'react';
import { RootObject } from '../../type';

import './style.less';


const HackBanner = (props: RootObject["hackathonBanner"]) => {

    const {
        backgroundImageUrl,
        subBackgroundImageUrl,
        registerWord,
        registerLink,
        detail,
        detailLink
    } = props;

    return (
        <div className='paddle-hack-banner-wrapper'>
            <div className='paddle-hack-banner-content' style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
                <div  className='paddle-hack-sub-wrapper'>
                    <div className='paddle-hack-sub-banner' style={{ backgroundImage: `url(${subBackgroundImageUrl})` }}></div>
                    <div className='paddle-hack-banner-btn-wrapper'>
                        <a href={registerLink} target='_blank' rel='noreferrer'>
                            <div className='register-btn'>{registerWord}</div>
                        </a>
                        <a href={detailLink} target='_blank' rel='noreferrer'>
                            <div className='detail-btn'>{detail}</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HackBanner;